module.exports = __webpack_public_path__ + "static/img/zhuangtai.495180f.png";


//////////////////
// WEBPACK FOOTER
// ./static/zhuangtai.png
// module id = eazC
// module chunks = 1